import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 580px;
  height: 580px;
`

export const Header = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid ${props => props.theme.colors.colord6dade};
`

export const Title = styled.div`
  font: normal normal bold 20px/24px Inter;
  color: ${props => props.theme.colors.color2d3139};
  opacity: 1;
`

export const Content = styled.div`
  position: relative;
  display: flex;
  padding: 5px 0;
  margin-top: 15px;
  flex: 1;
  overflow: hidden;
`

export const ChartArea = styled.div`
  position: relative;
  margin: 1rem;
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
`

export const EmptyMessage = styled.p`
  flex: 1;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;

  font: normal normal normal 14px/17px Inter;
  color: ${props => props.theme.colors.color6b7786};
`

export const PropertiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 200px;
  overflow: hidden;
`

export const PropertiesContainerHeader = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const PropertyTitle = styled.h3`
  position: relative;
  margin-top: 1rem;

  font-size: 1rem;
  text-align: center;
  font-weight: bold;
  color: ${props => props.theme.colors.color6b7786};
`

export const PropertiesTitle = styled.div`
  font: normal normal bold 16px/20px Inter;
  color: ${props => props.theme.colors.color2d3139};
`

export const PropertiesDate = styled.div`
  margin-top: 5px;
  font: normal normal normal 12px/15px Inter;
  color: ${props => props.theme.colors.color6b7786};
`

export const PropertiesList = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  margin-top: 8px;
  overflow: auto;
  overflow-x: hidden;
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${VerticalStyledScrollBar}
`

export const Footer = styled.div`
  display: flex;
  column-gap: 16px;
`

export const SuccessfulCopyMessage = styled.div`
  width: 200px;
  height: 30px;
  padding: 4px 0;
  text-align: center;
  font: normal normal normal 10px/22px Inter;
  color: ${({ theme }) => theme.zds.colors.neutral1000};
  background: ${props => props.theme.colors.color2d3139} 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 8px ${props => props.theme.colors.colorBlack29};
  border-radius: 6px;
  transition: 0 all ease-in;
`

export const ContainerLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(243, 245, 249, 0.7);
    border: 2px solid ${props => props.theme.colors.colord6dade};
    border-radius: 4px;
  }
`
export const ErrorContainer = styled.div`
  flex: 1;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;

  font: normal normal normal 14px/17px Inter;
  color: ${props => props.theme.colors.color6b7786};
`
